import { type CSSProperties, memo } from 'react';
import isEqual from 'react-fast-compare';

import { type Upload } from '@air/redux-uploader';

import { MobileTableRowContainer } from '~/components/TableView/MobileTableRow/MobileTableRowContainer';
import { UploadNameCell } from '~/components/TableView/NameCell/UploadNameCell';

export type MobileUploadTableRowProps = {
  upload: Upload;
  className?: string;
  /**
   * `react-virtualized` warns that `style` property should be included in the rendered cell for positioning
   * so we've separated it from the `tx` prop
   * */
  style?: CSSProperties;
};

export const MobileUploadTableRow = memo(
  ({ upload, ...props }: MobileUploadTableRowProps) => (
    <MobileTableRowContainer {...props}>
      <UploadNameCell upload={upload} />
    </MobileTableRowContainer>
  ),
  isEqual,
);

MobileUploadTableRow.displayName = 'MobileUploadTableRow';
